"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgSend(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: props.fill,
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.7.705A.49.49 0 00.145.83a.564.564 0 00-.104.59l2.487 6.14-2.495 7.043a.562.562 0 00.13.585.49.49 0 00.56.096L15.702 8.04A.544.544 0 0016 7.534a.54.54 0 00-.321-.489L.7.705zm2.715 6.302l-1.95-4.814 11.373 4.814H3.415zm.017 1.08l-2.009 5.67 11.72-5.67h-9.71z",
    fill: "inherit"
  }));
}

var _default = SvgSend;
exports.default = _default;